export const ChallengeDifficultyType = {
  BEGINNER: 'BEGINNER',
  INTERMEDIATE: 'INTERMEDIATE',
  ADVANCED: 'ADVANCED',
};

export const challengeDifficultyTypes = [
  ChallengeDifficultyType.BEGINNER,
  ChallengeDifficultyType.INTERMEDIATE,
  ChallengeDifficultyType.ADVANCED,
];
